<template>
  <BigScreenAdapter>
    <div id="index">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center host-body-bg">
          <div class="title">
            <img src="../../assets/juneng.png" class="title-img" />
            <div class="title-text">巨能重卡充电地图</div>
          </div>
        </div>

        <!-- 第二行 -->
        <div class="time-div">
          <div class="d-flex time-div-1">
            <span class="time-family">{{ year }} </span>年
            <span class="time-family">&nbsp;{{ month }} </span>月
            <span class="time-family">&nbsp;{{ day }} </span>日
            <span class="time-mag">
              <span class="time-family">{{ hour }}</span> :
              <span class="time-family">{{ minutes }}</span> :
              <span class="time-family">{{ seconds }}</span>
            </span>
            星期<span class="time-family">{{ dateWeek }}</span>
          </div>
        </div>
        <!-- 各个模块 -->
        <div class="grid-container">
          <div class="left-column">
            <!-- 全国数据地图 -->
            <div class="child-head">
              <div class="screen-city-box">
                <v-distpicker :province="province" :city="city" :hide-area="true" @province="chengProvince" @selected="chengCity"></v-distpicker>
              </div>
<!--              <div class="screen-city-box">-->

<!--                <div v-for="(item, index) in cityList" :key="index" :class="city == item.name-->
<!--                  ? 'screen-city-item active'-->
<!--                  : 'screen-city-item'-->
<!--                  " @click="chengCity(item)">-->
<!--                  {{ item.title }}-->
<!--                </div>-->
<!--              </div>-->

              <!-- 按钮 -->
<!--              <div class="screen-box">-->
<!--                <div :class="selectChargeStationTypeVal == item.id ? 'screen-item active' : 'screen-item'-->
<!--                  " @click="selectChargeStationTypeChange(item.id)" v-for="(item, index) in selectChargeStationType" :key="index">-->
<!--                  {{ item.value}}-->
<!--                </div>-->
<!--              </div>-->

              <!-- 按钮 -->
              <div class="screen-box">
                <div class="block">
                  <span class="demonstration">选项</span>
                  <el-cascader
                      v-model="selectedValues"
                      :options="options"
                      :props="{multiple: true, emitPath: true}"
                      @change="filterChange"
                      collapse-tags
                      popper-class="custom-cascader-popper"
                      clearable>
                    <template slot-scope="{node, data }">
                      <div v-if="data.isInput" class="range-inputs">
                        <el-input
                            v-if="data.value === 'text'"
                            v-model="data.text"
                            :placeholder="data.label"
                            size="mini"
                            @input="handleNameInput(node, data)"
                            @click.native.stop
                        />
                        <template v-else>
                          <el-input
                              v-model.number="data.min"
                              type="number"
                              placeholder="最小值"
                              size="mini"
                              @change="handleRangeInput(node, data, 'min')"
                          />
                          <span class="separator">-</span>
                          <el-input
                              v-model.number="data.max"
                              type="number"
                              placeholder="最大值"
                              size="mini"
                              @change="handleRangeInput(node, data, 'max')"
                          />
                        </template>
                      </div>
                      <span v-else class="custom-cascader-item">
                        <img v-show="data.icon" :class="{'blink-icon':data.isblink}" :src="data.icon" style="width: 18px;height: 18px;">
                        {{ data.label }}
                      </span>
                    </template>
                  </el-cascader>
                </div>

<!--                <div :class="screenVal == item.id ? 'screen-item active' : 'screen-item'-->
<!--                  " @click="screenChange(item.id)" v-for="(item, index) in screen" :key="index">-->
<!--                  <img v-if="item.id != '全国'" :src="screenVal == item.id ? item.icons : item.icon" alt="" />{{ item.value-->
<!--                  }}-->
<!--                </div>-->
              </div>
            </div>
            <ChartIndex ref="assRef" :shipList="shipList" :allList="allList"></ChartIndex>
          </div>
          <div class="right-column">
            <!-- 右边栏上部分 -->
            <div class="right-top">
              <countIndex :dataList="dataList"></countIndex>
            </div>
            <div class="right-middle">
              <proIndex :dataList="dataList.gardenAreaList"></proIndex>
            </div>
            <!-- 右边栏下部分 -->
            <div class="right-bottom">
              <dockIndex :dataList="dataList.chargeStationList"></dockIndex>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BigScreenAdapter>
</template>

<script>
import BigScreenAdapter from '../../components/BigScreenAdapter/index.vue'
import ChartIndex from './chartIndex.vue'
import proIndex from './proIndex.vue'
import dockIndex from './dockIndex.vue'
import countIndex from './countIndex.vue'
import { formatTime } from '../../utils/index.js'
import { getMainList } from '../../api/holdMy.js'
import {useRouter} from "vue-router/composables.mjs";


export default {
  components: { BigScreenAdapter, ChartIndex, proIndex, dockIndex, countIndex },
  data() {
    return {
      refreshTokening: null,
      refreshCity: null,
      timing: null,
      loading: false,
      dateWeek: '',
      weekday: ['日', '一', '二', '三', '四', '五', '六'],
      year: '',
      month: '',
      day: '',
      hour: '',
      minutes: '',
      // 原始数据
      dataList: {},
      seconds: '',
      screenVal: 'all',
      screen: [
        {
          value: '全部',
          id: 'all',
        },
        {
          value: '园区',
          id: 'gardenArea',
          icon: require(`../../assets/icons/18/unselected/gongyeyuanqu.png`),
          icons: require(`../../assets/icons/18/selected/gongyeyuanqu.png`),
        },
        {
          value: '充电站',
          id: 'chargeStation',
          icon: require(`../../assets/icons/18/unselected/qichexiangguan-chongdianzhan.png`),
          icons: require(`../../assets/icons/18/selected/qichexiangguan-chongdianzhan.png`),
        },
        {
          value: '路线',
          id: 'car',
          icon: require(`../../assets/icons/18/unselected/kuangka.png`),
          icons: require(`../../assets/icons/18/selected/kuangka.png`),
        },
      ],
      selectChargeStationTypeVal: null,
      selectChargeStationType: [
        {
          value: '全部',
          id: null
        },
        {
          value: '巨能',
          id: '0'
        },
        {
          value: '非巨能',
          id: '1'
        }
      ],
      // cityList: [
      //   { title: '全国',level:0, name: '' },
      //   {title: '福建省',level:1, name: '福建省'},
      //   { title: '厦门市',level:2, name: '厦门市' },
      // ],
      allList: [],
      chargeStationList: [],
      shipList: [],
      gardenAreaList: [],
      markersData: [],
      city: '市',
      province: '福建省',
      level: 0,
      timer: null,
      selectedValues: [],
      selectedRanges: [],
      options:[
        {
          value: 'chargeStation',
          label: '充电站',
          icon: require(`../../assets/icons/18/selected/qichexiangguan-chongdianzhan.png`),
          children: [
            {
              value: 'name',
              label: '充电站名称',
              children: [{value: 'text',// 用于标识文本输入框类型
                label: '模糊查询',isInput: true,
                text:null//文本内容
                }]
            },
            {
            value: 'chargeStationTypeValue',
            label: '充电站类型',
            icon: require(`../../assets/icons/18/selected/qichexiangguan-chongdianzhan.png`),
            children: [
              { value: 0, label: '巨能' },
              { value: 1, label: '非巨能' }
            ]
          },
            {
              value: 'manufacturer',
              label: '充电站厂家',
              icon: require(`../../assets/icons/18/selected/qichexiangguan-chongdianzhan.png`),
              children: [
                { value: 0, label: '远乐' },
                { value: 1, label: '特来电' },
                { value: 2, label: '星星充电' },
                { value: 3, label: '云快充' },
                { value: 4, label: '小鹏汽车' },
                { value: 5, label: '启源芯动力' },
                { value: 6, label: '扬充' },
                { value: 7, label: '卢川' },
                { value: 8, label: '巨能充' },
                { value: 9, label: '新电途' },
                { value: 10, label: '永智充' },
                { value: 11, label: '群龙' },
                { value: 12, label: '滴滴充电' },
                { value: 13, label: '芬充' },
              ]
            },
          {
          value: 'keynoteFlag',
          label: '重点项目',
          children: [
            { value: 0, label: '普通项目',icon:require('../../assets/icons/60/充电站.png') },
            { value: 1, label: '重点项目',icon:require('../../assets/icons/60/充电站yellow.png') },
            { value: 2, label: '超重点项目',icon:require('../../assets/icons/60/充电站red.png') }
          ]
          },
          {
            value: 'propertyRightValue',
            label: '产权',
            children: [
              { value: 0, label: '明确' },
              { value: 1, label: '未定' }
            ]
          },{
              value: 'chargeStationStatusValue',
              label: '站点状态',
              children: [
                { value: 0, label: '在建' ,icon:require('../../assets/icons/60/充电站.png') },
                { value: 1, label: '使用中' ,icon:require('../../assets/icons/60/充电站.png'), isblink:true }
              ]
            },{
              value: 'landStatusValue',
              label: '土地性质',
              children: [
                { value: 0, label: '工业' },
                { value: 1, label: '商业' },
                { value: 2, label: '建筑用地' },
                { value: 3, label: '集体' },
                { value: 4, label: '矿产资源用地' }
              ]
            },{
              value: 'area',
              label: '充电站面积(平方米)',
              children: [
                { value: 'range', label: '填写范围', isInput: true,min:null,max:null }
              ]
            },{
              value: 'chargingPileSpecValue',
              label: '充电桩规格',
              children: [
                { value: 0, label: '320KW' },
                { value: 1, label: '360KW' },
                { value: 2, label: '400KW' },
                { value: 3, label: '160KW' },
                { value: 4, label: '240KW' },
                { value: 5, label: '800KW' }
              ]
            },{
              value: 'largeCarParkNum',
              label: '大车停车位',
              children: [
                { value: 'range', label: '填写范围', isInput: true,min:null,max:null }
              ]
            },{
              value: 'carParkNum',
              label: '小车停车位',
              children: [
                { value: 'range', label: '填写范围', isInput: true,min:null,max:null }
              ]
            },{
              value: 'serviceCharge',
              label: '服务费',
              children: [
                { value: 'range', label: '填写范围', isInput: true,min:null,max:null }
              ]
            },{
              value: 'usePersent',
              label: '使用率',
              children: [
                { value: 'range', label: '填写范围', isInput: true,min:null,max:null }
              ]
            }]
        }, {
          value: 'gardenArea',
          label: '园区',
          icon: require('../../assets/icons/18/selected/gongyeyuanqu.png'),
          children: [{
            value: 'gardenAreaTypeValue',
            label: '园区类型',
            icon: require('../../assets/icons/18/selected/gongyeyuanqu.png'),
            children: [
              { value: 0, label: '港口', icon: require('../../assets/icons/60/港口.png')},
              { value: 1, label: '矿山', icon: require('../../assets/icons/60/kuangshan.png') },
              { value: 2, label: '停车场', icon: require('../../assets/icons/60/停车场.png') },
              { value: 3, label: '物流园区', icon: require('../../assets/icons/60/物流.png') },
              { value: 4, label: '工厂', icon: require('../../assets/icons/60/gongyeyuanqu.png') },
              { value: 5, label: '电厂', icon: require('../../assets/icons/60/电厂.png') },
              { value: 6, label: '水泥厂', icon: require('../../assets/icons/60/水泥拌合站.png') },
              { value: 7, label: '造纸厂', icon: require('../../assets/icons/60/工厂.png') },
              { value: 8, label: '钢铁厂', icon: require('../../assets/icons/60/钢铁厂.png') },
              { value: 9, label: '建材', icon: require('../../assets/icons/60/建材.png') },
            ]
          },{
              value: 'keynoteFlag',
              label: '重点项目',
              children: [
                { value: 0, label: '普通项目' },
                { value: 1, label: '重点项目' },
                { value: 2, label: '超重点项目' }
              ]
            },
            {
            value: 'freightPropValue',
            label: '货物类型',
            children: [
              { value: 0, label: '电子产品' },
              { value: 1, label: '食品' },
              { value: 2, label: '煤炭' },
              { value: 3, label: '矿石' },
              { value: 4, label: '谷物' },
              { value: 5, label: '水泥' },
              { value: 6, label: '石油' },
              { value: 7, label: '化学品' },
              { value: 8, label: '液化天然气' },
              { value: 9, label: '石块' },
              { value: 10, label: '沙子' },
              { value: 11, label: '钢铁' }
            ]
          }]
        },{
            value: 'transportRoute',
            label: '运输路线',
            children: [{
              value: 'carTypeValue',
              label: '重卡类型',
              children: [
                { value: 0, label: '自卸车', icon: require('../../assets/icons/60/zixieche.png') },
                { value: 1, label: '牵引半挂车', icon: require('../../assets/icons/60/qianyinche.png') },
                { value: 2, label: '矿卡' , icon: require('../../assets/icons/60/kuangka.png')},
                { value: 3, label: '载货车' , icon: require('../../assets/icons/60/peisong.png')},
                { value: 4, label: '搅拌车' , icon: require('../../assets/icons/60/jiaobanche-xian.png')},
                { value: 5, label: '水泥车' , icon: require('../../assets/icons/60/shuiniche.png')}
              ]
            }]
          }]
    }
  },
  mounted() {
    //检查是否有token，没有的话跳转到登录页面
    if (localStorage.getItem("token")) {
      var a = 1;
    }else {
      useRouter().push("/")
    }

    this.timeFn();
    this.getMain(this.city,this.level)
    // this.addCityRefreshScale()
    // this.addRefreshScale()
    // 添加鼠标移动事件监听器
    document.addEventListener('mousemove', this.handleMouseMove)
    // this.chengCity();
  },
  beforeDestroy() {
    this.clearDestroy()
  },
  destroyed() {
    // 在组件销毁时移除鼠标移动事件监听器
    document.removeEventListener('mousemove', this.handleMouseMove)
  },
  methods: {
    /* eslint-disable no-undef */
    // 处理名称输入
    handleNameInput(node, data) {

      // 生成唯一标识（示例：chargeStation:area:100~200）
      let parentPath = "";
      for (let i = 0; i < node.parent.path.length; i++) {
        parentPath += node.parent.path[i];
        if (i != node.parent.path.length - 1) {
          parentPath += ":";
        }
      }

      // 生成范围值标识（如：chargeStation:area:100~200）
      const rangeValue = `${parentPath}:${data.text ?? ''}`

      // 更新选中值
      this.updateSelectedValues(node, rangeValue)

      // 手动触发 change 事件
      this.$nextTick(() => {
        this.filterChange(node)
      })
    },
    //监听筛选中的数值输入
    handleRangeInput(node, data, type){
      // 验证数值有效性
      if (isNaN(data.min)) data.min = null;
      if (isNaN(data.max)) data.max = null;
      // 验证范围有效性：需同时为数字且min≤max
      if (
          typeof data.min === 'number' &&
          typeof data.max === 'number' &&
          data.min <= data.max
      ) {
        // 生成唯一标识（示例：chargeStation:area:100~200）
        let parentPath = "";
        for (let i = 0; i < node.parent.path.length; i++) {
          parentPath += node.parent.path[i];
          if (i != node.parent.path.length - 1) {
            parentPath += ":";
          }
        }
        // 生成范围值标识（如：chargeStation:area:100~200）
        const rangeValue = `${parentPath}:${data.min ?? ''}~${data.max ?? ''}`

        // 更新选中值
        this.updateSelectedValues(node, rangeValue)

        // 手动触发 change 事件
        this.$nextTick(() => {
          this.filterChange(node)
        })
      }
    },
    // 更新选中值数组
    updateSelectedValues(node, newValue) {

      // 添加新值（当输入有效时）
      if ((node.data.min !== null && node.data.max !== null) || (node.data.text != null)) {
        // 构建完整路径数组（如：['chargeStation', 'area', 'range']）
        const fullPath = [];
        for (let i = 0; i < node.parent.path.length; i++) {
          fullPath.push(node.parent.path[i])
        }
        // 2. 最后添加 newValue
        if (node.data.min !== null && node.data.max !== null) {
          fullPath.push("range");
        }else if (node.data.text != null) {
          fullPath.push("text");
        }

        // 过滤旧值：移除同路径的旧范围值
        let newSelectedValues = [];
        this.selectedValues.forEach(item => {
          if (item[0] != fullPath[0] || item[1] != fullPath[1] || item[2] != fullPath[2]) {
            newSelectedValues.push(item);
          }
        })
        this.selectedValues = [];
        this.selectedValues = this.selectedValues.concat(newSelectedValues);
        // 添加新值
        this.selectedValues.push(fullPath)

        //数值过滤
        let nowSelectedRanges = [];
        this.selectedValues.forEach((item,index) => {
          if (item[2] == 'range') {
            for (let i = this.selectedRanges.length - 1; i >= 0; i--) {
              if (item[0] == this.selectedRanges[i][0] && item[1] == this.selectedRanges[i][1]) {
                nowSelectedRanges.push(this.selectedRanges[i]);
                break;
              }
            }
          }else if (item[2] == 'text') {
            for (let i = this.selectedRanges.length - 1; i >= 0; i--) {
              if (item[0] == this.selectedRanges[i][0] && item[1] == this.selectedRanges[i][1]) {
                nowSelectedRanges.push(this.selectedRanges[i]);
                break;
              }
            }
          }
        })
        this.selectedRanges = [];
        this.selectedRanges.push(...nowSelectedRanges);

        // 3.将数值存储到额外的对象
        let newList = Array.from(fullPath);
        newList[2]=newValue;
        this.selectedRanges.push(newList)
      }
    },

    filterChange() {
      //过滤旧值
      let nowSelectedRanges = [];
      let nowSelectedText = [];
      this.selectedValues.forEach((item,index) => {
        if (item[2] == 'range') {
          for (let i = this.selectedRanges.length - 1; i >= 0; i--) {
            if (item[0] == this.selectedRanges[i][0] && item[1] == this.selectedRanges[i][1]) {
              // 从selectedRanges中匹配实际值
              nowSelectedRanges.push(this.selectedRanges[i]);
              break;
            }
          }
        }else if (item[2] == 'text') {
          for (let i = this.selectedRanges.length - 1; i >= 0; i--) {
            if (item[0] == this.selectedRanges[i][0] && item[1] == this.selectedRanges[i][1]) {
              nowSelectedText.push(this.selectedRanges[i]);
              break;
            }
          }
        }
      })
      // 合并普通选项和范围选项
      let result = [];
      this.selectedValues.forEach(item => {
        if (item[2] != 'range' && item[2] != 'text') {
          result.push(item);
        }
      })
      nowSelectedRanges.forEach(item => {
        let parse = this.parseRangeValue(item);
        let newItem = [];
        newItem.push(...item)
        newItem[2] = {min:parse[1], max: parse[2]};
        result.push(newItem);
      })
      nowSelectedText.forEach(item =>{
        let parse = this.parseTextValue(item);
        let newItem = [];
        newItem.push(...item);
        newItem[2] = {text: parse[1]};
        result.push(newItem);
      })
      // console.log('最终结果selectedValues:', this.selectedValues)
      // console.log('最终结果selectedRanges:', nowSelectedRanges)
      console.log('最终结果result:', result)

      this.setAllList(result);
    },

    // 解析范围值
    parseRangeValue(path) {
      const rangeStr = path[path.length - 1]
      const parts = rangeStr.split(':')

      // 示例路径：chargeStation:area:100~200
      const fieldType = parts[parts.length - 3] // 获取字段类型
      const [min, max] = parts[parts.length - 1].split('~').map(Number)

      return [fieldType, min, max]
    },
    //解析文本值
    parseTextValue(path) {
      const rangeStr = path[path.length - 1]
      const parts = rangeStr.split(':')
      // 示例路径：chargeStation:name:'达达'
      const fieldType = parts[parts.length - 3] // 获取字段类型
      const text = parts[parts.length - 1];

      return [fieldType, text]
    },

    // 清除定时器
    clearDestroy() {
      clearInterval(this.refreshImgIng)
      clearInterval(this.refreshCity)
    },

    // 定时刷新数据
    addRefreshScale() {
      // clearInterval(this.refreshImgIng)
      // // 重新加载船只
      // let _this = this
      // _this.getMain(this.city,this.level)
      // _this.refreshImgIng = setInterval(() => {
      //   _this.getMain(_this.city,this.level)
      // }, 1000 * 30)
    },
    // 点击切换省
    chengProvince(cityObj) {
      if (cityObj.value){
        if (cityObj.value == "省") {
          this.$refs.assRef.setMapCenter(null,6);
          this.$refs.assRef.map.centerAndZoom(new BMap.Point(120.31, 29.15), 8);
        }else {
          this.$refs.assRef.setMapCenter(cityObj.value,8);
        }
      }
      this.addRefreshScale()
    },
    // 点击切换城市
    chengCity(cityObj) {
      const {province, city} = cityObj;
      if (city.value) {
        if (city.value == "市") {
          this.chengProvince(province);
        }else {
          this.$refs.assRef.setMapCenter(city.value,12);
        }
      }
      this.addRefreshScale()
    },

    // 获取城市列表
    getMain(city,level) {
      let data = {}
      getMainList(data)
          .then((res) => {
            if (res.code == 200) {
              this.$set(this, 'dataList', res.data)
              this.setAllList()
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },

    // 监听鼠标活动
    handleMouseMove() {
      // 每次鼠标活动都重新开始计时
      clearTimeout(this.timer)
      clearInterval(this.refreshCity)
      // 5分钟后执行数据切换操作
      this.timer = setTimeout(() => {
        // 在这里执行数据切换的操作
        // this.addCityRefreshScale()
        this.addRefreshScale()
      }, 5 * 60 * 1000) // 5分钟 = 5 * 60秒 * 1000毫秒
    },

    // 构造数据
    setAllList(filter) {
      // 合并数据到一个数组
      this.allList = []
      this.chargeStationList = []
      this.gardenAreaList = []
      this.carList = []
      this.dataList.chargeStationList.forEach((item) => {

        //判断是否过滤
        let isShow = true;
        if (filter && filter.length != 0) {
          // 1. 筛选出第一个元素是 "chargeStation" 的子数组
          const filteredData = filter.filter(item => item[0] === "chargeStation")
          if (filteredData.length == 0) {
            isShow = false;
            return;
          }
          let filterParam = filteredData.reduce((acc, [_, key, value]) => {
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(value);
            return acc;
          }, {});

          //判断
          for (const key in filterParam) {
            //子级的充电桩等对象需要特殊处理
            if (key == 'chargingPileSpecValue') {
              let hasFlag = false;
              //判断数据是否包含过滤条件的充电桩类型条件
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filterParam[key].includes(parseInt(item.jnChargePileList[i].chargingPileSpecValue,10))) {
                  hasFlag = true;
                }
              }
              if (hasFlag) {
                continue;
              } else {
                isShow = false;
                break;
              }
            }
            if (typeof filterParam[key] == 'object' && typeof filterParam[key][0] == 'object') {
              //范围的数据过滤{min:xxx,max:xxx}
              if (filterParam[key][0].min != null) {
                if (item[key] >= filterParam[key][0].min && item[key] <= filterParam[key][0].max) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }else if (filterParam[key][0].text != null) {
                let str = item[key]+'';
                if (str.includes(filterParam[key][0].text)) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }

            }
            //如果不是范围型，则直接对比数值是否相等
            if (filterParam[key].map(String).includes(item[key])) {
              continue;
            } else {
              isShow = false;
              break;
            }
          }

        }
        if (!isShow) {
          //如果不显示，则跳过本次迭代
          return;
        }

        let iconUrl = null;
        let pileNum = 0;//充电桩总量
        item.jnChargePileList.forEach((item) => {
          pileNum += item.chargingPileNum;
        });
        if (item.keynoteFlag == '0') {
          iconUrl = require("../../assets/icons/120/充电站.png");
        } else if (item.keynoteFlag == '1'){
          iconUrl = require("../../assets/icons/120/充电站yellow.png");
        }else if (item.keynoteFlag == '2'){
          iconUrl = require("../../assets/icons/120/充电站red.png");
        }
        var location = require('coordtransform').wgs84togcj02(item.longitude,item.latitude);
        // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);

        let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
                "<div>名称:" + item.name + '</div>';
        if (item.allChargingPileStr) {
          content += '<div>充电桩：' + item.allChargingPileStr + '</div>';
        }
        if (item.address) {
          content += '<div>地址：' + item.address + '</div>'
        }
        if (item.sysAttachmentList) {
          let imageUrlList = [];
          item.sysAttachmentList.forEach(image => {
            imageUrlList.push("/dev-api"+image.attachmentName)//prod-api
            content += "<el-image src='"+"/dev-api"+image.attachmentName+"'>"
          })

        }

        content += '</el-card>';
        this.chargeStationList.push({
          chargeStationTypeValue: item.chargeStationTypeValue,
          coordinates: [location[0],location[1]],
          // iconUrl: item.type == '1' ? require(`../../assets/map/Bulk-cargo-terminal.${item.keynoteFlag == 1 ? 'gif' : 'png'}`) : require(`../../assets/map/wharf.${item.keynoteFlag == 1 ? 'gif' : 'png'}`),
          iconUrl: iconUrl,
          keynoteFlag: item.keynoteFlag,
          pileNum: pileNum,
          chargeStationStatusValue: item.chargeStationStatusValue,
          tooltipText: item.name,
          popupContent: content

        });
      })

      this.dataList.gardenAreaList.forEach((item) => {
        //判断是否过滤
        let isShow = true;
        if (filter && filter.length != 0) {
          // 1. 筛选出第一个元素是 "chargeStation" 的子数组
          const filteredData = filter.filter(item => item[0] === "gardenArea")
          if (filteredData.length == 0) {
            isShow = false;
            return;
          }
          let filterParam = filteredData.reduce((acc, [_, key, value]) => {
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(value);
            return acc;
          }, {});

          //判断
          for (const key in filterParam) {
            //子级的充电桩等对象需要特殊处理
            if (key == 'chargingPileSpecValue') {
              let hasFlag = false;
              //判断数据是否包含过滤条件的充电桩类型条件
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filterParam[key].includes(item.jnChargePileList[i].chargingPileSpecValue)) {
                  hasFlag = true;
                }
              }
              if (hasFlag) {
                continue;
              } else {
                isShow = false;
                break;
              }
            }
            if (typeof filterParam[key] == 'object' && typeof filterParam[key][0] == 'object') {
              //范围的数据过滤{min:xxx,max:xxx}
              if (filterParam[key][0].min != null) {
                if (item[key] >= filterParam[key][0].min && item[key] <= filterParam[key][0].max) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }else if (filterParam[key][0].text != null) {
                let str = item[key]+'';
                if (str.includes(filterParam[key][0].text)) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }
            }
            //如果不是范围型，则直接对比数值是否相等
            if (filterParam[key].map(String).includes(item[key])) {
              continue;
            } else {
              isShow = false;
              break;
            }
          }

        }
        if (!isShow) {
          //如果不显示，则跳过本次迭代
          return;
        }


        let iconUrl = null;
        if (item.keynoteFlag == '2') {
          if (item.gardenAreaTypeValue == '0') {
            iconUrl = require("../../assets/icons/120/港口.png")
          }
          else if (item.gardenAreaTypeValue == '1') {
            iconUrl = require("../../assets/icons/120/非煤矿山.png")
          }
          else if (item.gardenAreaTypeValue == '2') {
            iconUrl = require("../../assets/icons/120/停车场.png")
          }
          else if (item.gardenAreaTypeValue == '3') {
            iconUrl = require("../../assets/icons/120/物流.png");
          }
          else if (item.gardenAreaTypeValue == '4') {
            iconUrl = require("../../assets/icons/120/工厂.png");
          }
          else if (item.gardenAreaTypeValue == '5') {
            iconUrl = require("../../assets/icons/120/电厂.png");
          }
          else if (item.gardenAreaTypeValue == '6') {
            iconUrl = require("../../assets/icons/120/水泥拌合站.png");
          }
          else if (item.gardenAreaTypeValue == '7') {
            iconUrl = require("../../assets/icons/120/工厂.png");
          }
          else if (item.gardenAreaTypeValue == '8') {
            iconUrl = require("../../assets/icons/120/钢铁厂.png");
          }
          else if (item.gardenAreaTypeValue == '9') {
            iconUrl = require("../../assets/icons/120/建材.png");
          }else {
            iconUrl = require("../../assets/icons/120/gongyeyuanqu.png")
          }
        } else {
          if (item.gardenAreaTypeValue == '0') {
            iconUrl = require("../../assets/icons/60/港口.png")
          }
          else if (item.gardenAreaTypeValue == '1') {
            iconUrl = require("../../assets/icons/60/非煤矿山.png")
          }
          else if (item.gardenAreaTypeValue == '2') {
            iconUrl = require("../../assets/icons/60/停车场.png")
          }
          else if (item.gardenAreaTypeValue == '3') {
            iconUrl = require("../../assets/icons/60/物流.png");
          }
          else if (item.gardenAreaTypeValue == '4') {
            iconUrl = require("../../assets/icons/60/工厂.png");
          }
          else if (item.gardenAreaTypeValue == '5') {
            iconUrl = require("../../assets/icons/60/电厂.png");
          }
          else if (item.gardenAreaTypeValue == '6') {
            iconUrl = require("../../assets/icons/60/水泥拌合站.png");
          }
          else if (item.gardenAreaTypeValue == '7') {
            iconUrl = require("../../assets/icons/60/工厂.png");
          }
          else if (item.gardenAreaTypeValue == '8') {
            iconUrl = require("../../assets/icons/60/钢铁厂.png");
          }
          else if (item.gardenAreaTypeValue == '9') {
            iconUrl = require("../../assets/icons/60/建材.png");
          }
          else {
            iconUrl = require("../../assets/icons/60/gongyeyuanqu.png")
          }
        }
        var location = require('coordtransform').wgs84togcj02(item.longitude,item.latitude);
        // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);
        let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
            "<div>名称:" + item.name + '</div>';
        if (item.address) {
          content += '<div>地址：' + item.address + '</div>'
        }

        content += '</el-card>';
        this.gardenAreaList.push({
          coordinates: [location[0],location[1]],
          iconUrl: iconUrl,
          tooltipText: item.name,
          keynoteFlag: item.keynoteFlag,
          popupContent: content,
        })
      })
      this.dataList.carList.forEach((item) => {
        //判断是否过滤
        let isShow = true;
        if (filter && filter.length != 0) {
          // 1. 筛选出第一个元素是 "chargeStation" 的子数组
          const filteredData = filter.filter(item => item[0] === "transportRoute")
          if (filteredData.length == 0) {
            isShow = false;
            return;
          }
          let filterParam = filteredData.reduce((acc, [_, key, value]) => {
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(value);
            return acc;
          }, {});

          //判断
          for (const key in filterParam) {
            //子级的充电桩等对象需要特殊处理
            if (key == 'chargingPileSpecValue') {
              let hasFlag = false;
              //判断数据是否包含过滤条件的充电桩类型条件
              for (let i = 0; i < item.jnChargePileList.length; i++) {
                if (filterParam[key].includes(item.jnChargePileList[i].chargingPileSpecValue)) {
                  hasFlag = true;
                }
              }
              if (hasFlag) {
                continue;
              } else {
                isShow = false;
                break;
              }
            }
            if (typeof filterParam[key] == 'object' && typeof filterParam[key][0] == 'object') {
              //范围的数据过滤{min:xxx,max:xxx}
              if (filterParam[key][0].min != null) {
                if (item[key] >= filterParam[key][0].min && item[key] <= filterParam[key][0].max) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }else if (filterParam[key][0].text != null) {
                let str = item[key]+'';
                if (str.includes(filterParam[key][0].text)) {
                  continue;
                } else {
                  isShow = false;
                  break;
                }
              }
            }
            //如果不是范围型，则直接对比数值是否相等
            if (filterParam[key].map(String).includes(item[key])) {
              continue;
            } else {
              isShow = false;
              break;
            }
          }

        }
        if (!isShow) {
          //如果不显示，则跳过本次迭代
          return;
        }


        let iconUrl = null;
        if (item.keynoteFlag == '2') {
          iconUrl = require("../../assets/icons/120/kuangka.png");
        } else {
          iconUrl = require("../../assets/icons/60/kuangka.png");
        }
        //经纬度转化
        var location = require('coordtransform').wgs84togcj02(item.longitude,item.latitude);
        // var location = require('coordtransform').gcj02tobd09(location1[0], location1[1]);

        //对折线点经纬度进行转化
        var positions = JSON.parse(item.positions);
        if (positions) {
          for (let i = 0; i < positions.length; i++) {
            let position = require('coordtransform').wgs84togcj02(positions[i][1],positions[i][0]);
            positions[i] = [position[0],position[1]];
          }
        }

        let content = "<el-card style='padding: 10px 20px;line-height: 22px;'>" +
            "<div>名称:" + item.carNumber + '</div>';
        if (item.address) {
          content += '<div>地址：' + item.address + '</div>'
        }

        content += '</el-card>';
        this.carList.push({
          coordinates: [location[0],location[1]],
          positions: positions,
          iconUrl: iconUrl,
          tooltipText: item.carNumber,
          keynoteFlag: item.keynoteFlag,
          popupContent: content,
        })
      })
      this.allList = [...this.chargeStationList, ...this.gardenAreaList, ...this.carList]
      this.screenChange(this.screenVal)
    },

    //是否巨能过滤
    selectChargeStationTypeChange(id) {
      this.selectChargeStationTypeVal = id;
      if (this.screenVal == 'all') {
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.allList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
      }
      if (this.screenVal == 'gardenArea') {
        this.markersData = this.gardenAreaList
      }
      if (this.screenVal == 'chargeStation') {
        this.markersData = this.chargeStationList
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.chargeStationList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = filter;
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = filter;
        }
      }
      if (this.screenVal == 'car') {
        this.markersData = this.carList
      }
      setTimeout(() => {
        this.$refs.assRef.addTXMarker(this.markersData, false, this.city)
      })
    },

    // 切换状态
    screenChange(id) {
      this.screenVal = id
      //地图上需要画的点
      this.markersData = []
      //是否画船点
      var isReloadShip = false
      if (this.screenVal == 'all') {
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.allList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = [...filter, ...this.gardenAreaList, ...this.carList];
        }
      }
      if (this.screenVal == 'gardenArea') {
        this.markersData = this.gardenAreaList
      }
      if (this.screenVal == 'chargeStation') {
        this.markersData = this.chargeStationList
        if (this.selectChargeStationTypeVal == null) {
          this.markersData = this.chargeStationList
        }
        if (this.selectChargeStationTypeVal == '0') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '0');
          this.markersData = filter;
        }
        if (this.selectChargeStationTypeVal == '1') {
          let filter = this.chargeStationList.filter(item => item.chargeStationTypeValue == '1');
          this.markersData = filter;
        }
      }
      if (this.screenVal == 'car') {
        this.markersData = this.carList
      }
      setTimeout(() => {
        this.$refs.assRef.addTXMarker(this.markersData, isReloadShip, this.city)
      })
    },

    // 动态显示时间
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
        //年
        this.year = new Date().getFullYear()
        //月份是从0月开始获取的，所以要+1;
        var month = new Date().getMonth() + 1
        this.month = month < 10 ? '0' + month : month
        //日
        var day = new Date().getDate()
        this.day = day < 10 ? '0' + day : day
        var hour = new Date().getHours() // 时
        this.hour = hour < 10 ? '0' + hour : hour
        var minutes = new Date().getMinutes() // 分
        this.minutes = minutes < 10 ? '0' + minutes : minutes
        var seconds = new Date().getSeconds() //秒
        this.seconds = seconds < 10 ? '0' + seconds : seconds
      }, 1000)
    },
    /* eslint-enable no-undef */
  },
}
</script>

<style lang="scss">
.el-card {
  border-radius: 12px; /* 圆角设计 */
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%); /* 渐变背景 */
  box-shadow: 0 6px 20px rgba(31,38,135,0.15); /* 柔和阴影 */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); /* 过渡动画 */
}
.el-card__header {
  background: rgba(255,255,255,0.9);
  border-bottom: 1px solid #ebeef5;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  padding: 14px 20px;
}
.el-card__body {
  padding: 20px !important;
  background: rgba(245,247,250,0.95); /* 半透明背景 */
}
.el-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31,38,135,0.2);
}
</style>

<style lang="scss" scoped>
@import '../../assets/scss/index.scss';
.custom-cascader-popper {
  .range-inputs {
    padding: 8px;
    display: flex;
    align-items: center;
    gap: 5px;

    .el-input {
      width: 90px;
      .el-input__inner {
        padding: 0 5px;
      }
    }
  }

  .cascader-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.grid-container {
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  height: 976px;
  display: grid;
  grid-template-columns: 1560px auto;
  /* 左边栏固定宽度，右边自适应 */
  grid-column-gap: 20px;
  padding-right: 30px;
  /* 栏间距 */
}

.left-column {
  width: 1560px;
}

.right-column {
  display: grid;
  grid-template-rows: auto auto auto;
  /* 上下两栏自适应高度 */
  grid-row-gap: 20px;
  /* 行间距 */
  margin-top: 28px;
}

.right-top {}

.right-bottom {}

.child-head {
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: flex-end;
  padding-right: 20px;
}

.screen {
  &-box {
    display: flex;
  }

  &-item {
    height: 36px;
    background: #003168;
    border: 1px solid #054589;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #00a4ff;
    line-height: 36px;
    text-align: center;
    margin-left: 10px;
    padding: 0 10px;
    cursor: pointer;
    display: flex;
    width: 95px;
    justify-content: center;
    align-items: center;

    img {
      margin-right: 5px;
    }

    &.active {
      color: #fff;
      box-shadow: inset 0px -5px 20px 0px rgba(0, 164, 255, 0.3803921569);
    }
  }
}

.screen-city-box {
  background-image: url('../../assets/bottom.png');
  background-size: 100% 100%;
  height: 48px;
  width: 313px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.screen-city-item {
  flex: 1;
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0;
  cursor: pointer;
}

.screen-city-item.active {
  background-image: url('../../assets/Select.png');
  background-size: 100% 100%;
  height: 41px;
  width: 161px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #01fffd;
}
</style>
